import { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './DefaultCompactHeader.module.css';

const DefaultCompactHeader = ({
    aiDetectionElement,
    intercomElement,
    realTimeUpdateElement = null,
    auxiliaryElement = null,
    locationName,
    gateName,
    direction,
}) => {
    const InOutStyle = `${styles['default-compact-header--gate-info']} ${direction === 'IN' ? styles['default-compact-header--gate-in-style'] : styles['default-compact-header--gate-out-style']}`;
    return (
        <div className={styles['default-compact-header--wrapper']}>
            <div className={styles['default-compact-header-location-gate--info']}>
                <div className={styles['default-compact-header--location']}>{locationName}</div>
                <div className={InOutStyle}>
                    <span>{direction}</span> • <span>{gateName}</span>
                </div>
            </div>
            <div className={styles['default-compact-header--info']}>
                <div>{aiDetectionElement}</div>
                <div>{intercomElement}</div>
                <div>{realTimeUpdateElement}</div>
                {auxiliaryElement && <div>{auxiliaryElement}</div>}
            </div>
        </div>
    );
};

DefaultCompactHeader.propTypes = {
    aiDetectionElement: PropTypes.element.isRequired,
    intercomElement: PropTypes.element.isRequired,
    realTimeUpdateElement: PropTypes.element,
    auxiliaryElement: PropTypes.element,
};

export default memo(DefaultCompactHeader);
